/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { createRoute } from '@gh/common-shared';
import { ButlListComponent } from './components/butl-list/butl-list.component';
import { ButlListBusinessService } from './resources/butl-list-business.service';

const routes: Routes = [createRoute({
  component: ButlListComponent,
  path: '',
  init: ButlListBusinessService,
  auth: {
    permission: 'BulkUpdateTaskLog.VIEW',
  },
})];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderButlRoutingModule {
}
